import api from "../api/axios";
import dayjs from "dayjs";

const { REACT_APP_DEBUG_MODE: DEBUG_MODE } = process.env;

export const fetchOrders = async (createdDate = null, deliveryDate = null, short = false) => {
  console.log("createdDate inside fetch Order", createdDate);
  console.log("deliveryDate inside fetch Order", deliveryDate);

  const formattedCreatedDate = createdDate ? "createdAt=" + createdDate : "";
  const formattedDeliveryDate = deliveryDate ? "deliveryDate=" + deliveryDate : "";
  const shortParam = short ? "?short=true" : "";

  const result = await api.get(
    "/orders/" + formattedCreatedDate + formattedDeliveryDate + shortParam,
  );
  DEBUG_MODE && console.log("[ORDERS] RESULT OF QUERY", result.data);
  return result.data;
};

export const fetchDuplicateOrders = async (deliveryDate, orderIds) => {
  const response = await api.post("/orders/duplicates", {
    delivery_date: deliveryDate,
    order_ids: orderIds,
  });
  return response.data;
};

export const fetchOrderByID = async (id) => {
  const response = await api.get("/orders/" + id);
  const result = await response.data;
  return result;
};

export const removeOrders = async (ordersID) => {
  const val = await api.post("/orders/delete", { order_id: ordersID });
  console.log(val);
  return val;
};

export const createOrder = async (rawOrder) => {
  // const order
  const order = {
    daily_id: rawOrder.daily_id,
    name: rawOrder.name,
    address: rawOrder.name,
    amount: rawOrder.amount,
    city: rawOrder.city,
    phone_number: rawOrder.phone_number,
    products: ["120 kg Safari - lavanda", "20 kg Minino - lavanda"],
    // products: [
    //   { product_name: "easy clean", variant: "lavanda", quantity: 6 },
    //   { product_name: "minino", variant: "lavanda", quantity: 1 },
    // ],
    seller: rawOrder.seller,
    payment: "Pagado", // Pendiente
    observation: "Dejar en conserjería", // Pendiente
    raw: "Orden insertada por Business Copilot",
  };
  console.log(order);
  const val = api.post("/orders/create", order);
  return val;
};

export const getGroupedOrders = (orders, driversTemplate) => {
  // console.log("Entrando a getGrpuedOders");
  const ordersByCity = orders.reduce((acc, order) => {
    acc[order.city] = (acc[order.city] || 0) + 1;
    return acc;
  }, {});

  // Create initial data structure
  const initialData = {
    groups: {},
    groupOrder: [],
  };

  driversTemplate.forEach(({ driver, city }) => {
    if (!initialData.groups[driver]) {
      initialData.groups[driver] = {
        id: driver,
        title: driver,
        cards: [],
      };
      initialData.groupOrder.push(driver);
    }
    // console.log("ordersbyCity", ordersByCity);
    if (ordersByCity[city] > 0) {
      initialData.groups[driver].cards.push({
        id: city,
        content: city,
        number: ordersByCity[city],
      });
    }
  });

  // console.log(initialData);
  return initialData;
};

const initialData = {
  groups: {
    Victor: {
      id: "group-1",
      title: "Group 1",
      cards: [
        { id: "card-1", content: "Card 1", number: 10 },
        { id: "card-2", content: "Card 2", number: 20 },
        { id: "card-3", content: "Card 3", number: 30 },
      ],
    },
    "group-2": {
      id: "group-2",
      title: "Group 2",
      cards: [
        { id: "card-4", content: "Card 4", number: 40 },
        { id: "card-5", content: "Card 5", number: 50 },
      ],
    },
    "group-3": {
      id: "group-3",
      title: "Group 3",
      cards: [],
    },
    "group-4": {
      id: "group-4",
      title: "Group 4",
      cards: [],
    },
    "group-5": {
      id: "group-5",
      title: "Group 5",
      cards: [],
    },
  },
  groupOrder: ["group-1", "group-2", "group-3", "group-4", "group-5"],
};

const resolveDriverId = (drivers, driverName) => {
  const match = drivers.find((d) => d.name === driverName);
  if (!match) {
    console.warn(`[assignDriverToOrders] Chofer no encontrado: "${driverName}". Choferes disponibles: ${drivers.map((d) => d.name).join(", ")}`);
    return null;
  }
  return match.personnel_id;
};

// Picks the delivery this route day is actually for, instead of assuming
// it's always the last entry — an order can carry more than one delivery
// (rescheduled/duplicated), and the most-recently-created one isn't
// necessarily the one for `routeDay`. Mirrors RouteStep1's `todayDelivery`
// lookup so both steps of the wizard agree on which delivery is "this one".
const findRouteDayDelivery = (order, routeDay) => {
  const deliveries = order.delivery_info_array || [];
  const forRouteDay = routeDay
    ? deliveries.find((d) => d.delivery_date?.startsWith(routeDay))
    : null;
  return forRouteDay || deliveries[deliveries.length - 1];
};

const buildDeliveryPayload = (driversList, driversCity, orders, routeDay) => {
  const result = [];
  driversCity.forEach((item) => {
    const driver_id = resolveDriverId(driversList, item.driver_name);
    if (driver_id === null) return;
    item.cities.forEach((city) => {
      orders
        .filter((order) => order.city === city)
        .forEach((order) => {
          const delivery = findRouteDayDelivery(order, routeDay);
          if (!delivery?.delivery_id) {
            console.warn(`[assignDriverToOrders] Pedido sin delivery_id: ${order.daily_id}`);
            return;
          }
          result.push({ delivery_id: delivery.delivery_id, driver_id });
        });
    });
  });
  return result;
};

export const assignDriverToOrders = async (
  groupedData,
  groupedDataMayorista,
  groupedDataExternal,
  orders,
  drivers,
  ordersMinorista,
  ordersMayorista,
  ordersExternal,
  routeDay,
) => {
  const toDriversCity = (groups) =>
    Object.keys(groups).map((driver) => ({
      driver_name: driver,
      cities: groups[driver].cards.map((card) => card.id),
    }));

  const result = buildDeliveryPayload(
    drivers,
    toDriversCity(groupedData.groups),
    ordersMinorista,
    routeDay,
  );
  const resultMayorista = buildDeliveryPayload(
    drivers,
    toDriversCity(groupedDataMayorista.groups),
    ordersMayorista,
    routeDay,
  );

  console.log("[assignDriverToOrders] minorista payload:", result);
  console.log("[assignDriverToOrders] mayorista payload:", resultMayorista);

  if (result.length > 0)
    await api.post("/orders/edit/driver", { delivery_info: result });
  if (resultMayorista.length > 0)
    await api.post("/orders/edit/driver", { delivery_info: resultMayorista });

  if (ordersExternal?.length > 0 && groupedDataExternal?.groups) {
    const resultExternal = buildDeliveryPayload(
      drivers,
      toDriversCity(groupedDataExternal.groups),
      ordersExternal,
      routeDay,
    );
    console.log("[assignDriverToOrders] external payload:", resultExternal);
    if (resultExternal.length > 0) {
      await api.post("/orders/edit/driver", { delivery_info: resultExternal });
    }
  }
};

export const editOrderByID = async (obj) => {
  const data = {
    order_id: obj.order_id,
    daily_id: obj.daily_id,
    name: obj.name,
    address: obj.address,
    amount: obj.amount,
    city: obj.city,
    seller_id: obj.seller_id,
    order_type: obj.order_type,
  };
  console.log("ACTUAL DATA HERE FOR EDIT ORDER", data);
  const val = await api.post("/orders/edit", data);
  console.log("val", val);
  return val;
};

export const addOrderProduct = async (orderID, productToAdd) => {
  const data = { order_id: Number(orderID), product: productToAdd };
  console.log("data", data);
  const val = await api.post("/orders/add/product", data);
  return val;
};

export const deleteOrderProduct = async (orderProductID) => {
  const data = { order_product_id: Number(orderProductID) };
  const val = await api.post("/orders/remove/product", data);
  return val;
};

export const editDeliveryOrder = async (deliveryInfo) => {
  const data = {
    delivery_id: deliveryInfo.delivery_id,
    delivery_status: deliveryInfo.delivery_status,
    delivery_date: deliveryInfo.delivery_date,
    delivery_note: deliveryInfo.delivery_note,
    driver_id: deliveryInfo.driver_id,
  };

  const val = await api.post("/orders/edit/delivery", data);

  return val;
};

export const addDeliveryOrder = async (deliveryInfo) => {
  const data = {
    order_id: deliveryInfo.order_id,
    delivery_status: deliveryInfo.delivery_status,
    delivery_date: dayjs(deliveryInfo.delivery_date).format("YYYY-MM-DD"),
    delivery_note: deliveryInfo.delivery_note,
    driver: deliveryInfo.driver_id,
  };

  const val = await api.post("/orders/add/delivery", data);

  console.log("[API] Add Delivery Order", val);
  return val;
};

export const deleteDeliveryOrder = async (deliveryID) => {
  const data = {
    delivery_id: deliveryID,
  };

  const val = await api.post("/orders/delete/delivery", data);

  // console.log("val", val);
  return val;
};

export const uploadDeliveryImage = async (deliveryId, file) => {
  const formData = new FormData();
  formData.append("file", file);
  const val = await api.post(`/deliveries/${deliveryId}/images`, formData);
  return val.data;
};

export const deleteDeliveryImage = async (imageId) => {
  const val = await api.delete(`/deliveries/images/${imageId}`);
  return val;
};

const apiUrls = {
  deliveryDate: "orders/detail/",
  createdAt: "pending",
};

export const fetchOrdersInitialEndDate = async (dates, type) => {
  const apiUrl = apiUrls[type] + dates.initialDate + "/" + dates.endDate;
  const val = await api.get(apiUrl);
  return val;
};
